import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const updateDinars = useCallback((balance) => {
    if (typeof balance !== "number") return;
    setUser((current) => (
      current && typeof current === "object" && current.dinars !== balance
        ? { ...current, dinars: balance }
        : current
    ));
  }, []);
  const refresh = async () => {
    if (!getToken()) { setUser(false); return false; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  };
  useEffect(() => { refresh(); }, []);
  useEffect(() => {
    const onDinarUpdate = (event) => {
      const balance = event.detail?.dinars_balance ?? event.detail?.balance;
      updateDinars(balance);
    };
    window.addEventListener("arabdex:dinar-update", onDinarUpdate);
    return () => window.removeEventListener("arabdex:dinar-update", onDinarUpdate);
  }, [updateDinars]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setToken(null); setUser(false); };
  return (
    <AuthCtx.Provider value={{ user, setUser, updateDinars, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
